import httpClient from "services/httpClient";

export async function request(config) {
  const response = await httpClient(config);
  let _return;

  const status = response.resStatusCode || response.status;

  if (status === 200 || 201) {
    _return = {
      data: { ...response.resData },
      status,
    };
  } else if (status === 204) {
    _return = {
      data: null,
      status,
    };
  } else {
    _return = {
      data: { ...response.data.data },
      status,
    };
  }

  return _return;
}

